import styled from 'styled-components';

export const Container = styled.span`
  font-size: 16px;
  font-family: 'Exo';
  font-weight: normal;
  color: ${({ theme }) => theme.colors.blue};
  width: fit-content;
`;
